<template>
  <div class="" style="padding: 50px 0px 0px 0px">
    <div class="form_title">QUERO ECONOMIZAR</div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-select
        name="state"
        v-model="state"
        label="Estado"
        :hint="'Selecione o seu estado'"
        :items="states"
        item-text="nome"
        item-value="sigla"
        :rules="[(v) => !!v || 'Por favor, selecione o seu estado!']"
        prepend-icon="map"
        required
        persistent-hint
        single-line
      ></v-select>
      <!--
            <select v-model="state">
                <option disabled value="">Escolha um item</option>
                <option v-for="(state, idx) in states" :key="idx" :value="state.sigla">{{ state.nome }}</option>
            </select><br>
            -->
      <v-text-field
        v-model="email"
        :rules="emailRules"
        label="E-mail"
        prepend-icon="email"
        required
      ></v-text-field>
      <v-text-field
        v-model="name"
        :rules="nameRules"
        label="Nome Completo"
        prepend-icon="person"
        required
      ></v-text-field>
      <!--
            <v-text-field
                v-model="password"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="Senha"
                hint="Pelo menos 8 caracteres"
                counter
                @click:append="show1 = !show1"
            ></v-text-field>

            <v-text-field
                v-model="confirm_password"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="Confirmar Senha"
                hint="Pelo menos 8 caracteres"
                counter
                @click:append="show1 = !show1"
            ></v-text-field>
            -->
      <v-text-field
        v-model="phone"
        :rules="phoneRules"
        prepend-icon="phone"
        label="Celular"
        required
      ></v-text-field>
      <v-text-field
        v-model="promo_code"
        label="Código de Indicação"
        prepend-icon="record_voice_over"
        hint="um amigo(a) lhe indicou? Informe o código aqui"
      ></v-text-field>
      <v-text-field
        v-model="average_consumption"
        :rules="average_consumptionRules"
        :mask="average"
        prefix="R$"
        value="300,00"
        label="Média de Consumo"
        required
      ></v-text-field>
      <!--
            <input type="password" v-model="password" placeholder="Senha"><br>
            <input type="password" v-model="confirm_password" placeholder="Confirmar Senha"><br>
            <input type="text" v-model="phone" placeholder="Celular"><br>
            <input type="text" v-model="promo_code" placeholder="Código de Indicação"><br>
            <input type="text" v-model="average_consumption" placeholder="Média de Consumo"><br>
            
            <button @click="signUp">Cadastrar</button>
            -->
      <v-flex xs12 sm12 md12 style="text-align: right">
        <v-btn :disabled="!valid" color="success" @click="signUp" flat large>
          CONTINUAR
        </v-btn>
        <!-- <span>ou retornar para <router-link to="/login">login</router-link></span> -->
      </v-flex>
    </v-form>
  </div>
</template>

<script>
import { addLead } from "../services/leads";
import statesfile from "../model/state";

export default {
  name: "signUp",
  data() {
    return {
      valid: false,
      states: statesfile.estados,
      email: "",
      emailRules: [
        (v) => !!v || "Por favor, informe o seu email",
        (v) => /.+@.+/.test(v) || "E-mail precisa ser válido",
      ],
      name: "",
      nameRules: [
        (v) => !!v || "Por favor, informe o seu nome",
        (v) => v.length >= 10 || "Por favor, preencha seu nome completo.",
      ],
      password: "",
      confirm_password: "",
      state: { nome: "Minas Gerais", sigla: "MG" },
      phone: "",
      phoneRules: [
        (v) => !!v || "Por favor, informe o seu celular",
        (v) =>
          v.length > 10 || "Ops. Parece que esse não é um número de telefone",
      ],
      promo_code: this.$route.query.promo_code || "",
      average_consumption: "",
      step: 0,
      customer_id: "",
      show1: false,
      rules: {
        required: (value) => !!value || "Obrigatório.",
        min: (v) => v.length >= 8 || "Min 8 caracteres",
        emailMatch: () => "E-mail ou senha incorretos",
      },
    };
  },
  mounted() {},
  methods: {
    signUp: function () {
      let user = {
        customer_id: this.email,
        email: this.email,
        name: this.name,
        state: this.state,
        phone: this.phone,
        promo_code: this.promo_code,
        average_consumption: this.average_consumption,
        step: this.step,
      };

      addLead(user)
        .then((result) => {
          if (result.data) {
            localStorage.setItem("lead", JSON.stringify(user));
            this.$router.replace("home");
          }
        })
        .catch(() => {
          console.error("Erro ao adicionar lead.");
        });
    },
  },
};
</script>

<style scoped>
.signUp {
  margin-top: 60px;
}
input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}
button {
  margin-top: 10px;
  width: 10%;
  cursor: pointer;
}
span {
  display: block;
  margin-top: 20px;
  font-size: 11px;
}
.form_title {
  font-size: 2em;
  color: rgb(99, 97, 97);
  font-weight: bold;
}
</style>
